/**
 * Created by IL on 17/06/16.
 */

import { Dispatcher as BaseDispatcher } from '../../../../_common/platform/ts/BaseDispatcher';

export class Dispatcher extends BaseDispatcher {
    public handleViewAction(action) {
        this.dispatch({
            source: 'VIEW_ACTION',
            action: action
        });
    }

    public static get() {
        return new Dispatcher();
    }
}
